import React, { useEffect, useState } from 'react';

const API = '/api';
const BANCOS = ['Afirme', 'Banorte', 'Banamex', 'Banregio', 'HSBC', 'Santander', 'Scotiabank', 'Notarías Autorizadas'];
const TABS = ['Todos', ...BANCOS];

const st = {
  page: { padding: '0', maxWidth: 1180 },
  titlebar: { display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 4 },
  h1: { fontFamily: 'Georgia, "Source Serif Pro", serif', fontWeight: 500, fontSize: 28, margin: 0, letterSpacing: '-0.01em', color: '#1F2328' },
  subtitle: { color: '#5B6470', fontSize: 14, margin: '4px 0 28px 0' },
  toolbar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 },
  tabs: { display: 'flex', gap: 2, flexWrap: 'wrap' },
  tab: (active) => ({
    padding: '7px 14px', fontSize: 13.5, border: 'none', background: 'none', cursor: 'pointer',
    color: active ? '#1F2328' : '#5B6470',
    borderBottom: active ? '2px solid #1B3A5C' : '2px solid transparent',
    fontWeight: active ? 600 : 400,
  }),
  btnUpload: { background: '#1B3A5C', color: 'white', border: 'none', padding: '9px 16px', borderRadius: 4, fontSize: 13.5, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6 },
  ledger: { background: '#FFFFFF', border: '1px solid #E4E1D9', borderRadius: 6, overflow: 'hidden' },
  ledgerHead: { display: 'grid', gridTemplateColumns: '44px 1fr 120px 90px 44px', padding: '10px 18px', fontSize: 11.5, color: '#5B6470', borderBottom: '1px solid #E4E1D9', background: '#FCFCFA' },
  row: { display: 'grid', gridTemplateColumns: '44px 1fr 120px 90px 44px', alignItems: 'center', padding: '14px 18px', borderBottom: '1px solid #E4E1D9' },
  badge: { width: 30, height: 30, borderRadius: 4, background: '#E9EEF3', color: '#1B3A5C', fontSize: 11, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  docTitle: { fontSize: 14.5, fontWeight: 500, color: '#1F2328' },
  docBank: { fontSize: 12, color: '#5B6470', marginTop: 2 },
  docDate: { fontSize: 13, color: '#5B6470', fontVariantNumeric: 'tabular-nums' },
  docSize: { fontSize: 13, color: '#5B6470', fontVariantNumeric: 'tabular-nums' },
  dlBtn: { width: 30, height: 30, borderRadius: 4, border: '1px solid #E4E1D9', background: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#1F2328', textDecoration: 'none' },
  rowActions: { display: 'flex', gap: 6 },
  iconBtnDanger: { width: 30, height: 30, borderRadius: 4, border: '1px solid #E4E1D9', background: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#A8362B' },
  empty: { padding: '60px 20px', textAlign: 'center', color: '#5B6470', fontSize: 14 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(20,20,18,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10 },
  modal: { background: '#FFFFFF', width: 420, borderRadius: 8, padding: 24, border: '1px solid #E4E1D9' },
  modalH2: { fontSize: 17, margin: '0 0 18px 0', fontWeight: 600, color: '#1F2328' },
  field: { marginBottom: 14 },
  label: { display: 'block', fontSize: 12.5, color: '#5B6470', marginBottom: 5 },
  input: { width: '100%', padding: '8px 10px', border: '1px solid #E4E1D9', borderRadius: 4, fontSize: 13.5, background: '#FAFAF8', boxSizing: 'border-box', fontFamily: 'inherit' },
  dropzone: (active) => ({
    border: `1.5px dashed ${active ? '#1B3A5C' : '#E4E1D9'}`, borderRadius: 6, padding: 22, textAlign: 'center',
    fontSize: 13, color: '#5B6470', cursor: 'pointer', background: active ? '#E9EEF3' : 'transparent',
  }),
  modalActions: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20 },
  btnSecondary: { background: 'none', border: '1px solid #E4E1D9', padding: '8px 14px', borderRadius: 4, fontSize: 13, cursor: 'pointer', color: '#1F2328' },
  error: { color: '#A8362B', fontSize: 12.5, marginTop: 6 },
};

const INITIALS_OVERRIDE = { Banorte: 'BN', Banregio: 'BR', Banamex: 'BM' };

function initials(banco) {
  return INITIALS_OVERRIDE[banco] || banco.slice(0, 2).toUpperCase();
}

function formatFecha(iso) {
  return new Date(iso).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: '2-digit' }).replace('.', '');
}

function formatTamano(bytes) {
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${Math.round(bytes / 1024)} KB`;
}

async function descargarPdf(url, nombreArchivo) {
  const r = await fetch(url);
  if (!r.ok) return false;
  const blob = await r.blob();
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = nombreArchivo;
  link.click();
  URL.revokeObjectURL(link.href);
  return true;
}

export default function ActualizacionesBancoHome({ soloLectura = false }) {
  const [activeTab, setActiveTab] = useState('Todos');
  const [docs, setDocs] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [confirmarBaja, setConfirmarBaja] = useState(null);

  const cargar = () => {
    setCargando(true);
    const qs = activeTab !== 'Todos' ? `?banco=${encodeURIComponent(activeTab)}` : '';
    fetch(`${API}/actualizaciones-banco${qs}`)
      .then((r) => r.json())
      .then((d) => setDocs(Array.isArray(d) ? d : []))
      .finally(() => setCargando(false));
  };

  useEffect(() => {
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const archivar = async (id) => {
    await fetch(`${API}/actualizaciones-banco/${id}/archivar`, { method: 'PUT' });
    setConfirmarBaja(null);
    cargar();
  };

  return (
    <div style={st.page}>
      <div style={st.titlebar}>
        <h1 style={st.h1}>Actualizaciones Bancos</h1>
      </div>
      <p style={st.subtitle}>Comunicados, boletines y cambios de política de cada banco, en un solo lugar.</p>

      <div style={st.toolbar}>
        <div style={st.tabs}>
          {TABS.map((b) => (
            <button key={b} style={st.tab(activeTab === b)} onClick={() => setActiveTab(b)}>{b}</button>
          ))}
        </div>
        {!soloLectura && <button style={st.btnUpload} onClick={() => setShowModal(true)}>+ Subir documento</button>}
      </div>

      <div style={st.ledger}>
        <div style={st.ledgerHead}>
          <div></div>
          <div>Documento</div>
          <div>Fecha</div>
          <div>Tamaño</div>
          <div></div>
        </div>
        {!cargando && docs.length === 0 && (
          <div style={st.empty}>
            Aún no hay actualizaciones para {activeTab}.
            {!soloLectura && (
              <div style={{ marginTop: 14 }}>
                <button style={st.btnUpload} onClick={() => setShowModal(true)}>+ Subir el primer documento</button>
              </div>
            )}
          </div>
        )}
        {docs.map((d, i) => (
          <div key={d.id} style={{ ...st.row, borderBottom: i === docs.length - 1 ? 'none' : st.row.borderBottom }}>
            <div style={st.badge}>{initials(d.banco)}</div>
            <div>
              <div style={st.docTitle}>{d.titulo}</div>
              <div style={st.docBank}>{d.banco}</div>
            </div>
            <div style={st.docDate}>{formatFecha(d.fecha_subida)}</div>
            <div style={st.docSize}>{formatTamano(d.tamano_bytes)}</div>
            <div style={st.rowActions}>
              <div style={st.dlBtn} title="Descargar" onClick={() => descargarPdf(`${API}/actualizaciones-banco/${d.id}/descargar`, d.archivo_nombre_original || d.titulo)}>⬇</div>
              {!soloLectura && <div style={st.iconBtnDanger} title="Dar de baja" onClick={() => setConfirmarBaja(d)}>✕</div>}
            </div>
          </div>
        ))}
      </div>

      {showModal && <ModalSubir onClose={() => setShowModal(false)} onUploaded={() => { setShowModal(false); cargar(); }} />}

      {confirmarBaja && (
        <div style={st.overlay}>
          <div style={st.modal}>
            <h2 style={st.modalH2}>Dar de baja documento</h2>
            <p style={{ fontSize: 13.5, color: '#1F2328' }}>
              ¿Dar de baja "{confirmarBaja.titulo}"? Dejará de aparecer en la lista. Esta acción no se puede deshacer desde aquí.
            </p>
            <div style={st.modalActions}>
              <button style={st.btnSecondary} onClick={() => setConfirmarBaja(null)}>Cancelar</button>
              <button style={{ ...st.btnUpload, background: '#A8362B' }} onClick={() => archivar(confirmarBaja.id)}>Dar de baja</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function ModalSubir({ onClose, onUploaded }) {
  const [banco, setBanco] = useState(BANCOS[0]);
  const [titulo, setTitulo] = useState('');
  const [archivo, setArchivo] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [error, setError] = useState('');
  const [subiendo, setSubiendo] = useState(false);

  const validarArchivo = (file) => {
    if (!file) return null;
    if (!file.name.toLowerCase().endsWith('.pdf') || file.type !== 'application/pdf') {
      setError('El archivo debe ser un PDF.');
      return null;
    }
    if (file.size > 20 * 1024 * 1024) {
      setError('El archivo no puede superar 20 MB.');
      return null;
    }
    setError('');
    return file;
  };

  const onDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    const file = validarArchivo(e.dataTransfer.files[0]);
    if (file) setArchivo(file);
  };

  const onSelect = (e) => {
    const file = validarArchivo(e.target.files[0]);
    if (file) setArchivo(file);
  };

  const subir = async () => {
    if (!titulo.trim()) { setError('El título es obligatorio.'); return; }
    if (!archivo) { setError('Selecciona un archivo PDF.'); return; }
    setSubiendo(true);
    setError('');
    try {
      const fd = new FormData();
      fd.append('banco', banco);
      fd.append('titulo', titulo.trim());
      fd.append('archivo', archivo);
      const r = await fetch(`${API}/actualizaciones-banco`, { method: 'POST', body: fd });
      if (!r.ok) {
        const d = await r.json().catch(() => ({}));
        throw new Error(d.error || 'Error al subir el documento');
      }
      onUploaded();
    } catch (err) {
      setError(err.message);
    } finally {
      setSubiendo(false);
    }
  };

  return (
    <div style={st.overlay}>
      <div style={st.modal}>
        <h2 style={st.modalH2}>Subir documento</h2>
        <div style={st.field}>
          <label style={st.label}>Banco</label>
          <select style={st.input} value={banco} onChange={(e) => setBanco(e.target.value)}>
            {BANCOS.map((b) => <option key={b} value={b}>{b}</option>)}
          </select>
        </div>
        <div style={st.field}>
          <label style={st.label}>Título</label>
          <input
            type="text"
            style={st.input}
            placeholder="Ej. Novedades Hipotecario — Sep 2026"
            value={titulo}
            onChange={(e) => setTitulo(e.target.value)}
          />
        </div>
        <div style={st.field}>
          <label style={st.label}>Archivo</label>
          <label
            style={st.dropzone(dragActive)}
            onDragOver={(e) => { e.preventDefault(); setDragActive(true); }}
            onDragLeave={() => setDragActive(false)}
            onDrop={onDrop}
          >
            {archivo ? archivo.name : 'Arrastra un PDF aquí o haz clic para seleccionar'}
            <input type="file" accept="application/pdf,.pdf" onChange={onSelect} style={{ display: 'none' }} />
          </label>
        </div>
        {error && <div style={st.error}>{error}</div>}
        <div style={st.modalActions}>
          <button style={st.btnSecondary} onClick={onClose} disabled={subiendo}>Cancelar</button>
          <button style={st.btnUpload} onClick={subir} disabled={subiendo}>{subiendo ? 'Subiendo…' : 'Subir'}</button>
        </div>
      </div>
    </div>
  );
}
